/**
 * Created by weijianli on 2017/3/27.
 */
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

export default getQueryString;



// WEBPACK FOOTER //
// ./src/asset/vendor/getQueryString.js